export default __webpack_public_path__ + "static/manage-quotes-buyer-view-10e6a886e0b5318d3010806ea550d650.png";